<template>
    <div class="flex">
        <image-button
                @click.native="showModal = true"
                img="/images/svg/ATS3bdSeriesicon_tzut.svg">
            rate of change
        </image-button>

        <portal to="modals" v-if="showModal">
            <modal-bottom v-if="showModal" @close="close()" class="bg-grey-lighter">
                <h3 slot="header">Rate of Change</h3>

                <div slot="save" v-show="action !== null">
                    <a class="cursor-pointer inline-block bg-blue text-white px-4 py-2 rounded" v-show="true"
                       @click="save()">
                        Apply
                    </a>
                </div>

                <!--
                <p class="text-grey-dark text-sm">
                                    The rate of change quantifies how one quantity changes in relation to another
                                    quantity.
                                    The standard formular is: rate of change = value at time t/ value at time t-1
                                    expressed in %: rate of change % = (rate of change -1) * 100<br>

                                    Alternative comparisons available<br>
                                    Compute Difference<br>
                                    It calculates the difference between two quantities:
                                    difference = value at time t - value at time t-1
                                </p>
                -->

                <button
                        class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:bg-blue-lightest"
                        :class="{'bg-blue-lightest border-blue-dark': action === 'roc'}"
                        @click="toggle('roc')">Rate of Change
                </button>

                <button
                        class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        :class="{'bg-blue-lightest border-blue-dark': action === 'difference'}"
                        @click="toggle('difference')">
                    Compute Difference
                </button>

                <a @click="update('moving_average', selected)">.</a>

                <!-- @click.stop="update('index', selected, time); time = null"-->
            </modal-bottom>
        </portal>

    </div>
</template>

<script>

    import ImageButton from "../ImageButton";
    import ModalBottom from "../ModalBottom";
    import RateOfChangeModifier from "../../modifiers/RateOfChangeModifier";
    import DifferenceModifier from "../../modifiers/DifferenceModifier";

    export default {
        name: "ComputeRateOfChange",

        components: {ModalBottom, ImageButton},

        data: () => ({
            showModal: false,
            action: null,
        }),

        computed: {
            times() {
                return this.$store.getters.times;
            },
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
        },

        watch: {
            action() {
                this.modify()
            },
            showModal() {
                this.action = null;
            }
        },

        methods: {
            toggle(type) {
                this.action = this.action === type ? null : type;
            },
            close() {
                this.$store.dispatch('abort');
                this.showModal = false;
            },
            modify() {
                if (this.action === 'roc') {
                    this.$store.dispatch('setModifier', {
                        modifier: new RateOfChangeModifier(),
                        ids: this.selected
                    });
                }

                if (this.action === 'difference') {
                    this.$store.dispatch('setModifier', {
                        modifier: new DifferenceModifier(),
                        ids: this.selected
                    });
                }

                if (this.action === null) {
                    this.$store.dispatch('abort');
                }
            },
            save() {
                this.$store.dispatch('save');
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>
